import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { ApplicationService } from 'services/application.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-manageuser',
  templateUrl: './manageuser.component.html',
  styleUrls: ['./manageuser.component.scss']
})
export class ManageuserComponent implements OnInit {
  result: any;
  userId: any;
  selectedUser: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'firstname',
    'lastname',
    'email',
    'cellnumber',
    'reference',
    // 'identificationNumber',
    // 'action'

  ];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  resdata: any;
  isShowNodata: boolean = false;
  filterValue: string;
  data: any;

  constructor(private applicationservice: ApplicationService, private userservice: UserService,
    private navigate: NavigationService,
    private router: Router,


    private alertService: AlertService) { }

  ngOnInit() {
    this.getUserDetails(true);
    this.filterValue = '';
  }

  refresh() {
    this.getUserDetails(true);
    this.filterValue = '';
  }
  getUserDetails(refresh) {
    this.filterValue = '';
    this.applicationservice.getUserLogin(refresh).subscribe(res => {
      // this.result = res;
      if (res.length > 0) {
        this.resdata = res;

        this.dataSource = new MatTableDataSource(this.resdata);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

      }
      else {
        this.isShowNodata = true;
      }
    })
  }
  reset(item) {
    debugger
    var data = {
      "email": item.email
    }

    swal.fire({
      title: 'Are you sure',
      //  html:  +result.value.vumatelApiErrorMessage ,                   
      text: "Do you want to reset the password?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res.value) {

        this.userservice.resetPassword(data).subscribe(result => {

          if (result.value) {
            this.alertService.success("Password Reset Successfully");
          }
          else {
            this.alertService.error(result.htmlFormattedFailures);
          }

        });
      }
    });


  }

  onKeydown(event) {
    debugger
    if (event.key === "Enter") {
      const searchQuery = (this.filterValue || '').trim();
      if (searchQuery == null || searchQuery == '') {
        this.alertService.warning("Please enter a search query");
        return;
      }
      this.get(this.filterValue);
    }
  }
  get(filter) {
    debugger
    let search = {
      search: filter,
    }
    this.applicationservice.applyUserFilter(search).subscribe((result) => {
      this.data = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  onFilter() {
    debugger
    const searchQuery = (this.filterValue || '').trim();
    if (searchQuery == null || searchQuery == '') {
      this.alertService.warning("Please enter a search query");
      return;
    }
    this.get(this.filterValue);
  }

  applyFilter(filterValue: string) {
    debugger
    this.filterValue = filterValue.trim();
  }
  addUser() {
    this.navigate.addOrUpdateAdminLogin(null, true);
  }

  UpdateUser(user) {
    this.navigate.addOrUpdateAdminLogin(user, false);
  }

  // deleteUser(user) {
  //   const txt = 'Do you want delete user ' + user.firstName + ' ' + user.lastName + '?';
  //   const Yes = 'Yes';
  //   const No = 'No';
  //   swal.fire({
  //     text: txt,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#009DA0' ,
  //     cancelButtonColor: '#FF8D60',
  //     confirmButtonText: Yes,
  //     cancelButtonText: No,
  //   }).then((result) => {
  //     if (result.value) {
  //       const userId = user.id;
  //       this.applicationservice.deleteUser(userId).subscribe((
  //         res: any) => {
  //         if (res.isSuccess) {
  //           this.alertService.success("Deactivated Successfully");
  //           this.getUserDetails(true);
  //         }
  //         else {
  //           this.alertService.error("Oops Something went wrong.");
  //         }
  //       })
  //     }
  //   });
  // }
}
